import { $, _ } from "js/vendor";
import { getStaticUrl } from "js/config";

let splashScreenTimeout;

export function RemoveSplashScreen() {
    clearTimeout(splashScreenTimeout);

    $("#splash").addClass("hide-splash");
}

export function RestoreSplashScreen() {
    clearTimeout(splashScreenTimeout);

    splashScreenTimeout = setTimeout(() => {
        $("#splash").removeClass("hide-splash");
    }, 100);
}

export function ShowPlayerLoadingScreen() {
    const splashElement = $("#splash");
    if (!splashElement.length) {
        return;
    }

    splashElement.css("background", "black");

    // Find and update the existing image, or create a simple one if none exists
    const existingImage = splashElement.find("img").first();
    if (existingImage.length) {
        existingImage.attr("src", getStaticUrl("/images/splash.gif"));
    } else {
        // If no image exists, create a simple one
        splashElement.html(`<img src="${getStaticUrl("/images/splash.gif")}" alt="loading animation" />`);
    }

    splashElement.removeClass("hide-splash");
}

